import { Injectable, inject } from '@angular/core';
import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';
import { HttpService } from '@easy-lib/modules/shared/services/http.service';
import { apiUrls } from '@easy-lib/constants/api-urls.constant';
@Injectable({
	providedIn: 'root'
})
export abstract class BaseService {
	environment: EasyEnvironment = inject(EasyEnvironment);
	httpService: HttpService = inject(HttpService);
	get mtsPath(): string {
		return this.environment.setting.mtspath;
	}
	get apiUrls() {
		return apiUrls;
	}
}
